import { useStore } from "../../app/stores/store";
import DataTable, { FilterProps } from "../../app/common/DataTable";
import ConfirmComponent from "../../app/common/form/ConfirmComponent";
import DeleteIcon from "@mui/icons-material/Delete";
import { Button, Box } from "@mui/material";
import { Participant } from "../../app/models/participant";
import { useParams } from "react-router-dom";
import ParticipantAutocomplete from "./ParticipantAutoComplete";
import { useTranslation } from "react-i18next";

export default function ParticipantsTable() {
  const participantStore = useStore((s) => s.participantStore);
  const modalStore = useStore((s) => s.modalStore);
  const { id } = useParams();
  const { t } = useTranslation();

  const columns = [
    {
      key: "member.firstName",
      additionalKey: "familyMember.firstName",
      header: t("members.firstName"),
    },
    {
      key: "member.lastName",
      additionalKey: "familyMember.lastName",
      header: t("members.lastName"),
    },
    {
      key: "member.email",
      additionalKey: "familyMember.email",
      header: t("members.email"),
    },
    {
      key: "member.phone",
      additionalKey: "familyMember.phone",
      header: t("members.phone"),
    },
  ];
  const handleDelete = async (id: string) => {
    await participantStore.deleteParticipant(id);
    modalStore.closeModal();
  };
  const actionButtons = [
    {
      icon: <DeleteIcon color="error" />,
      onClick: (event: React.MouseEvent, item: Participant) => {
        event.stopPropagation();
        modalStore.openModal(
          <ConfirmComponent
            onYes={async () => handleDelete(item.id!)}
            onCancel={modalStore.closeModal}
          />
        );
      },
    },
  ];

  return (
    <>
      <Box sx={{ mb: 2 }}>
        <Button
          variant="contained"
          color="success"
          onClick={() =>
            modalStore.openModal(
              <ParticipantAutocomplete activityId={id || ""} />,
              "small"
            )
          }
        >
          {t("participants.addParticipant")}
        </Button>
      </Box>
      <DataTable
        columns={columns}
        data={participantStore.tableData}
        clickUrl={(item: any) =>
          `/update-member/${item.memberId ?? item["familyMember.memberId"]}`
        }
        actionButtons={actionButtons}
        onFilter={(filterProps: FilterProps) =>
          participantStore.loadParticipants(id!, filterProps)
        }
      />
    </>
  );
}
